// Authentication related pages (lazy loaded for code splitting)
import { lazy, Suspense } from "react";
import EventPage from "@/pages/Event/EventPage";
const DownloadPage = lazy(() => import("@/pages/Download/DownloadPage"));
const NotFound = lazy(() => import("pages/Errors/NotFound"));
const Login = lazy(() => import("pages/Authentication/Login"));
const LinkedinAuthRedirect = lazy(
  () => import("@/components/Spotlight/LinkedinAuthRedirect"),
);
const SponsorIq = lazy(() => import("@/pages/SponsorIq/SponsorIqPage"));
const GalleryPage = lazy(() => import("pages/Gallery/GalleryPage"));
const SpotlightPage = lazy(() => import("pages/Spotlight/SpotlightPage"));
const TeamsPage = lazy(() => import("pages/Team/TeamsPage"));
const OneQRPage = lazy(() => import("pages/OneQR/OneQRPage"));
const TransactionDetailsPage = lazy(
  () => import("pages/TransactionDetails/TransactionDetailsPage"),
);
const ReelitPage = lazy(() => import("pages/Reelit/ReelitPage"));
const GalleryRegisterPage = lazy(
  () => import("pages/Gallery/GalleryRegisterPage"),
);
const GalleryMainPage = lazy(() => import("pages/Gallery/GalleryMainPage"));
const GuestUploadPage = lazy(() => import("pages/GuestUpload/GuestUploadPage"));
import Loader from "@/components/Loader";

const ComponentWithSuspense = (Component) => {
  return (props) => {
    return (
      <Suspense fallback={<Loader className="ht-100 w-100" />}>
        <Component {...props} />
      </Suspense>
    );
  };
};

const nonDomainRoutes = [
  { path: "/login", component: ComponentWithSuspense(Login) },
  { path: "/404", component: ComponentWithSuspense(NotFound) },
  {
    path: "/auth-linkedin",
    component: ComponentWithSuspense(LinkedinAuthRedirect),
  },
  { path: "/download-links", component: ComponentWithSuspense(DownloadPage) },
  { path: "/download", component: ComponentWithSuspense(DownloadPage) },
];
//other routes
const routes = [
  { path: "/:page/:eventId", component: ComponentWithSuspense(EventPage) },
  { path: "/download-links", component: ComponentWithSuspense(DownloadPage) },
  { path: "/download", component: ComponentWithSuspense(DownloadPage) },
  // One QR Gallery
  {
    path: "/",
    component: ComponentWithSuspense(OneQRPage),
  },
];

// Regular routes without EventLayout
const eventRoutes = [
  {
    path: "/gallery/:eventId",
    component: ComponentWithSuspense(GalleryPage),
  },

  // sponsorIq
  {
    path: "/sponsoriq/:eventId",
    component: ComponentWithSuspense(SponsorIq),
  },

  {
    path: "/spotlight/:eventId",
    component: ComponentWithSuspense(SpotlightPage),
  },
  {
    path: "/teams/:eventId",
    component: ComponentWithSuspense(TeamsPage),
  },
  {
    path: "/transaction/:eventId",
    component: ComponentWithSuspense(TransactionDetailsPage),
  },
];

const galleryRoutesWithoutLayout = [
  {
    path: "/gallery/:eventId/reelit",
    component: ComponentWithSuspense(ReelitPage),
  },
];

// Gallery sub-routes (used within GalleryPage)
const gallerySubRoutes = [
  {
    path: "/gallery/:eventId/register",
    component: ComponentWithSuspense(GalleryRegisterPage),
  },
  {
    path: "/gallery/:eventId/guest-upload",
    component: ComponentWithSuspense(GuestUploadPage),
  },
  {
    path: "/gallery/:eventId",
    component: ComponentWithSuspense(GalleryMainPage),
  },
];

export {
  nonDomainRoutes,
  routes,
  eventRoutes,
  galleryRoutesWithoutLayout,
  gallerySubRoutes,
};
